<div class="custom-container">
  <div class="py-70">
    <app-section-heading [sectionHeading]="empower.sectionHeading" />

    <div class="empower-grid-template mt-45">
      <div
        class="card-container w-100 h-205"
        *ngFor="let card of empower.empowerCards"
      >
        <img [src]="card.icon.src" [alt]="card.icon.alt" />
        <p class="section-small-sub-title mt-35">
          {{ card.title }}
        </p>
        <p class="section-text max-w-245 mt-10">
          {{ card.description }}
        </p>

        <img
          src="assets/blueRadialGradient.svg"
          alt="blueRadialGradient"
          class="position-absolute top-0 start-0"
        />
      </div>
    </div>
  </div>
</div>
